// extracted by mini-css-extract-plugin
export default {"textInputLabel":"J5-z","textInput":"K5-z","error":"L5-z","disabled":"M5-z"};